<div class="container-box">
  <div class="flex mt-3">
    <div class="dynamic-form mx-4 my-2 w-3/12">
      <app-make-dropdown-ms
        [meta]="yearMeta"
        [triggerSelectionBrand$]="triggerYear$"
        [triggerUpdateComponent$]="triggerUpdateYear$"
      ></app-make-dropdown-ms>
    </div>
    <div class="dynamic-form mx-4 my-2 w-3/12">
      <app-make-dropdown-ms
        [meta]="quarterMeta"
        [triggerSelectionBrand$]="triggerQuarter$"
        [triggerUpdateComponent$]="triggerUpdateQuarter$"
      ></app-make-dropdown-ms>
    </div>
    <div class="dynamic-form mx-4 my-2 w-3/12">
      <app-make-dropdown-ms
        [meta]="monthMeta"
        [triggerSelectionBrand$]="triggerMonth$"
        [triggerUpdateComponent$]="triggerUpdateMonth$"
      ></app-make-dropdown-ms>
    </div>
    <div class="dynamic-form mx-4 my-2 w-3/12">
      <app-make-dropdown-ms
        [meta]="brandsMeta"
        [triggerSelectionBrand$]="triggerSelectionBrand$"
        [triggerUpdateComponent$]="triggerUpdateComponentSelectBrand$"
      ></app-make-dropdown-ms>
    </div>
  </div>
  <div class="flex">
    <div class="mx-4 my-2 w-full">
      <app-table-bigger-discount
        [triggerDate$]="triggerDate$"
        [brands]="brands"
      ></app-table-bigger-discount>
    </div>
  </div>
</div>
